<template>
  <div class="admin-companies-autocomplete" style="z-index: 999">
    <b-form-input
        class="admin-companies-autocomplete-input"
        v-model="search"
        :placeholder="placeholder"
        @input="onChangeInput"
        autocomplete="off"
    />
    <b-icon
        v-if="company"
        icon="x"
        class="admin-companies-autocomplete-clear cursor-pointer"
        @click.prevent="() => setCompany()"
    />
    <ul v-if="companies.length" class="admin-companies-autocomplete-list">
      <li
          v-for="(company, index) in companies"
          :key="index"
          class="admin-companies-autocomplete-list-item"
      >
        <b-link
            @click.prevent="() => setCompany(company)"
            class="admin-companies-autocomplete-list-item-link"
        >
          {{ company.name }}
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminCompaniesAutocomplete",
  props: ['value'],
  emits: ["update:modelValue"],
  data() {
    return {
      search: "",
      companies: [],
      list_visible: false
    }
  },
  computed: {
    company() {
      return this.value;
    },
    companyStatusId() {
      let status = this.$store.state.data.company_statuses.find(status => status.code === 'active');
      if (status) {
        return status.id;
      }
      return "";
    },
    placeholder() {
      if (this.company) {
        return this.company.name;
      }
      return "Search Companies";
    }
  },
  methods: {
    onChangeInput(value) {
      if (value) {
        this.searchCompanies();
      } else {
        this.companies = [];
      }
    },
    searchCompanies() {
      this.$api.get(API_ROUTES.ADMIN_COMPANIES, {
        params: {
          status: this.companyStatusId,
          search: this.search
        }
      }).then(({data}) => {
        this.companies = data.companies;
      })
    },
    setCompany(company = null) {
      this.search = "";
      this.$emit("input", company);
      this.companies = [];
    }
  }
}
</script>
